export default "__VITE_ASSET__CPoHgJ4S__"